<template>
    <div class="wrapper">
        <el-tabs v-model="active">
            <el-tab-pane label="Common" name="common">
                <view-status-tab v-bind:model="model"></view-status-tab>
            </el-tab-pane>
            <el-tab-pane label="Messages" name="messages">
                <view-messages-tab :url="messageIndexUrl" :campaign="model.id"></view-messages-tab>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  import ViewStatusTab from './view-common-tab';
  import ViewMessagesTab from './view-messages-tab';

  export default {
    components: {
      ViewStatusTab,
      ViewMessagesTab,
    },

    props: {
      model: {
        type: Object,
        default: function () {
          return {};
        },
      },
      messageIndexUrl: {
        type: String,
      },
    },

    data() {
      return {
        active: 'common',
      }
    },
  }
</script>